import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

export default async function signIn(email:string, password:string){

    try {

        await signInWithEmailAndPassword(getAuth(), email, password)
        return
        
    } catch (error) {
        throw error
    }

}